import { render, staticRenderFns } from "./link-icon.vue?vue&type=template&id=00965368&"
import script from "./link-icon.vue?vue&type=script&lang=js&"
export * from "./link-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports